import { useContext } from 'react'

import { Form as FormContainer } from 'components/Form'
import { EndAbTestContext } from '../context/EndAbTestContext'
import { Form } from './Form'
import { useEndAbTest } from './hooks/useEndAbTest'
import { schema, Schema, schemaDefaults } from './schema'

export const EndAbTestForm = (): JSX.Element => {
  const { abTest, formId, loading } = useContext(EndAbTestContext)
  const { endAbTest } = useEndAbTest()

  return (
    <FormContainer<Schema>
      id={formId}
      loading={loading}
      onSubmit={endAbTest}
      schema={schema}
      schemaDefaults={schemaDefaults(abTest)}
    >
      {() => <Form />}
    </FormContainer>
  )
}
